
;var cwMjs=window.cwMjs || {};

cwMjs.author={
    switchAuthorIndex: function () {

        $('h2 .btn-index').on('click', function (e) {
            e.preventDefault();
            $(this).addClass('hide').siblings('a').removeClass('hide');
            $('.author-list-box').addClass('hide');
            $('.author-index-list').removeClass('hide');
        });

        $('h2 .btn-detail').on('click', function (e) {
            e.preventDefault();
            $(this).addClass('hide').siblings('a').removeClass('hide');
            $('.author-list-box').removeClass('hide');
            $('.author-index-list').addClass('hide');
        });

    }
};